module.exports = __webpack_public_path__ + "img/nextIcon.562d8d76.svg";